<section
  class="row row-cols-1 row-cols-md-3 gy-5 gx-lg-5 align-items-md-baseline pt-2 px-4 px-md-5 px-lg-0"
>
  @for (item of sectionData(); track $index) {
    <article class="col d-flex flex-column row-gap-3 align-items-center text-center">
      <img [src]="item.img" [alt]="item.title" class="img-fluid" />
      <h4 class="inter-medium text-wrap px-3 px-md-4 px-xxl-5">{{ item.title }}</h4>
    </article>
  }
</section>
